import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import {
  currentDocuments,
  searchInDocs,
  userDocuments,
} from "../store/Documents";
import { useBoard } from "./database/useBoard";
import { IsPlatform, IsSort } from "../type/album";

export const platform: IsPlatform[] = ["youtube", "apple", "melon"];

export const useAlbum = () => {
  const [currentDocs, setCurrentDocs] = useRecoilState(currentDocuments);
  const [userDocs, setUserDocs] = useRecoilState(userDocuments);
  const [searchValue, setSearchValue] = useRecoilState(searchInDocs);

  const {
    documents,
    getAllDocuments,
    getDocumentByUidRealTime,
    getDocumentsByPlatform,
    getDocumentsByUid,
    getDocumentsByVocal,
    getDocumentById,
  } = useBoard();

  useEffect(() => {
    setUserDocs(documents || userDocs);
  }, [documents]);

  const getCurrentDocs = async () => {
    setCurrentDocs(await getAllDocuments());
  };

  // 수정
  const getUserDocs = async (uid: string, level: number) => {
    getDocumentByUidRealTime(uid, level);
  };

  const resetUserDocs = () => {
    setUserDocs(null);
  };

  const searchFilter = (userVocalList: string[], value: string) => {
    const result = userVocalList.filter((e) => {
      return e
        .replace(" ", "")
        .toLocaleLowerCase()
        .includes(value.toLocaleLowerCase().replace(" ", ""));
    });
    return result;
  };

  const resetSearchValue = () => {
    setSearchValue("");
  };

  const searchByVocal = async (vocal: string) => {
    setCurrentDocs(await getDocumentsByVocal(vocal));
    setSearchValue(vocal);
  };

  const searchByPlatform = async (platform: IsPlatform) => {
    setCurrentDocs(await getDocumentsByPlatform(platform));
    setSearchValue(platform);
  };

  const searchByUid = async (uid: string, username: string) => {
    setCurrentDocs(await getDocumentsByUid(uid));
    setSearchValue(username);
  };

  const getVocalList = () => {
    let result: string[] = [];
    currentDocs?.forEach((e) => {
      result.push(...(e.vocalList || ""));
    });
    return Array.from(new Set(result));
  };

  const getMyVocalList = () => {
    let result: string[] = [];
    userDocs?.forEach((e) => {
      result.push(...(e.vocalList || ""));
    });
    return Array.from(new Set(result));
  };

  return {
    currentDocs,
    userDocs,
    searchValue,
    resetSearchValue,
    getCurrentDocs,
    getUserDocs,
    resetUserDocs,
    searchByVocal,
    searchByPlatform,
    searchByUid,
    searchFilter,
    getVocalList,
    getMyVocalList,
  };
};
